import {
  cryptoUint32,
  randomBelow,
  type Uint32Source,
} from "@/lib/tool-kit/random-fun/rng";

/** Four full turns before the wheel settles. */
export const FULL_TURNS_DEG = 1440;
/** Where inside the winning segment the pointer lands, in steps of a thousandth. */
const OFFSET_STEPS = 1000;

/**
 * Which segment sits under the top pointer after the wheel has been rotated clockwise by
 * `rotationDeg`. Segment 0 starts at 12 o'clock.
 */
export function winningIndex(rotationDeg: number, count: number): number {
  const segmentDeg = 360 / count;
  const normalized = (((360 - (rotationDeg % 360)) % 360) + 360) % 360;
  return Math.floor(normalized / segmentDeg) % count;
}

/**
 * The rotation that ends a spin started from `rotation`: the winning segment is drawn
 * uniformly first (so each of the `count` options has exactly 1/count), then the wheel is
 * turned so that segment stops under the pointer, away from its edges.
 */
export function spinTarget(
  rotation: number,
  count: number,
  source: Uint32Source = cryptoUint32
): number {
  const segmentDeg = 360 / count;
  const winner = randomBelow(count, source);
  const within = (randomBelow(OFFSET_STEPS, source) + 0.5) / OFFSET_STEPS;
  const pointerAt = (winner + within) * segmentDeg;
  const wanted = (360 - pointerAt) % 360;
  const current = ((rotation % 360) + 360) % 360;
  const delta = (wanted - current + 360) % 360;
  return rotation + FULL_TURNS_DEG + delta;
}
